class ThemeLetter {
  constructor(el) {
    this.letterEl = el
  }

  activate() {
    this.letterEl.classList.add('active')
  }

  deactivate() {
    this.letterEl.classList.remove('active')
  }

  get letter() {
    return this.letterEl.innerHTML
  }
}

export default ThemeLetter
